module.exports = __webpack_public_path__ + "img/Software certificate.0a28da54.jpg";